/**
 * Version information structure stored in version.json
 */
export interface VersionInfo {
	readonly version: string;
	readonly buildVersion: string;
	readonly build: string;
	readonly buildDate: string;
	readonly commitHash: string;
	readonly releaseNotes: string[];
}

/**
 * Current version state in the application
 */
export interface CurrentVersionState {
	readonly current: VersionInfo | null;
	readonly latest: VersionInfo | null;
	readonly updateAvailable: boolean;
	readonly isChecking: boolean;
	readonly lastChecked: Date | null;
}

/**
 * Configuration for version checking
 */
export interface VersionCheckConfig {
	readonly checkInterval: number;
	readonly askLaterDelay: number;
	readonly versionUrl: string;
}

/**
 * Update dialog actions
 */
export const enum UpdateAction {
	UPDATE_NOW = 'update-now',
	ASK_LATER = 'ask-later'
}
